import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";

export const Columns = [
  {
    prop: "eventoId",
    label: "Id",
    minWidth: 30,
    sortable: true,
    fixed: true
  },
  {
    prop: "eventoName",
    label: "Descripcion",
    minWidth: 100,
    sortable: true,
    fixed: true
  },
  {
    prop: "fecha",
    label: "Fecha",
    minWidth: 60,
    sortable: true,
    fixed: true,
    formatter: DatetimeFormatter
  },
  {
    prop: "tarjetaid",
    label: "Tarjeta ID",
    minWidth: 60,
    sortable: true,
    fixed: true
  },
  {
    prop: "operador",
    label: "Operador",
    minWidth: 110,
    sortable: true,
    fixed: true
  },
  {
    prop: "estacion",
    label: "Estacion",
    minWidth: 110,
    sortable: true,
    fixed: true
  }
];
